/**
 * @fileoverview POST handler for "/apps/:app_group_id/user_imports/:import_id/transform_column_mapping"
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportIdTransformColumnMappingCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdUserImportsImportIdTransformColumnMappingProps,
  PostAppsAppGroupIdUserImportsImportIdTransformColumnMappingResult,
} from "./types";

export const postAppsAppGroupIdUserImportsImportIdTransformColumnMapping = reactQueryMutationAdapter(
  appsAppGroupIdUserImportsImportIdTransformColumnMappingCacheKeys,
  ({
    appGroupId,
    importId,
    dataMapId,
  }: PostAppsAppGroupIdUserImportsImportIdTransformColumnMappingProps): Promise<PostAppsAppGroupIdUserImportsImportIdTransformColumnMappingResult> => {
    return fetch(`/apps/${appGroupId}/user_imports/${importId}/transform_column_mapping`, "POST", {
      data_map_id: dataMapId,
    });
  }
);
